import { render, staticRenderFns } from "./tagNav.vue?vue&type=template&id=80a04510&scoped=true&"
import script from "./tagNav.vue?vue&type=script&lang=js&"
export * from "./tagNav.vue?vue&type=script&lang=js&"
import style0 from "./tagNav.vue?vue&type=style&index=0&id=80a04510&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a04510",
  null
  
)

export default component.exports